<script lang="ts">
  import { screen } from '#app/lib/components/stores/screen'
  import { debounce } from '#app/lib/svelte/utils.svelte.ts'
  import Masonry from '#components/Masonry.svelte'
  import Spinner from '#components/spinner.svelte'
  import ItemCard from '#inventory/components/item_card.svelte'
  import { getEstimatedHeight } from '#inventory/components/lib/masonry_helpers'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import type { ShelfId } from '#server/types/shelf'

  let {
    items,
    showDistance = false,
    shelfId,
    waiting,
    bottomOffsetTop = $bindable(),
  }: {
    items: SerializedItemWithUserData[]
    showDistance?: boolean
    shelfId?: ShelfId
    waiting?: Promise<unknown>
    bottomOffsetTop?: number
  } = $props()

  const baseColumnWidth = 230
  const gap = 16
  // Disabling animations as it sometimes fails to re-position item cards when the screen is resized
  const animate = false

  const columns = $derived.by(debounce(() => {
    if ($screen.width < (2 * baseColumnWidth + gap)) {
      return [
        Math.min($screen.width, baseColumnWidth),
        Math.min($screen.width - gap, baseColumnWidth * 1.5),
      ]
    } else {
      return [ baseColumnWidth, baseColumnWidth ]
    }
  }, 200))
  const minColWidth = $derived(columns[0])
  const maxColWidth = $derived(columns[1])
</script>

<div class="items-cascade">
  <!-- Reset Masonry on screen width change -->
  {#key $screen.width}
    <Masonry
      {items}
      idKey="_id"
      {gap}
      {minColWidth}
      {maxColWidth}
      {animate}
      {getEstimatedHeight}
      bind:bottomOffsetTop
    >
      {#snippet children({ item })}
        <!-- eslint-disable-next-line svelte/no-unused-svelte-ignore -->
        <!-- svelte-ignore ownership_invalid_binding -->
        <ItemCard {item} {showDistance} {shelfId} />
      {/snippet}
    </Masonry>
  {/key}

  {#await waiting}<Spinner center={true} />{/await}
</div>

<style lang="scss">
  @import "general/scss/utils";
  .items-cascade{
    margin: 1em 0;
  }
</style>
